import { Fragment, useSyncExternalStore, type ReactNode } from 'react';
import en from './en';
import es from './es';
import { idioma, suscribir, type Idioma } from './idioma';

export { idioma, IDIOMAS, locale, ponerIdioma, type Idioma } from './idioma';

/** Todos los textos del panel; el español tiene que tener las mismas claves (lo revisa TypeScript). */
export type Textos = typeof en;
const TEXTOS: Record<Idioma, Textos> = { en, es };

/**
 * Los textos en el idioma actual: `tx.appliances.titulo`. Se lee al pintar (nunca guardarlo
 * en una constante de módulo: quedaría en el idioma del arranque; para eso está `vivo`).
 */
export const tx: Textos = new Proxy({} as Textos, {
  get: (_, k) => TEXTOS[idioma()][k as keyof Textos],
});

export function useIdioma(): Idioma {
  return useSyncExternalStore(suscribir, idioma);
}

/** Vuelve a pintar todo al cambiar de idioma; los datos ya cargados se quedan. */
export function ConIdioma({ children }: { children: ReactNode }) {
  const i = useIdioma();
  return <Fragment key={i}>{children}</Fragment>;
}
